import ListWarehouses from "@/views/service_provider/warehouse/movements/ListWarehouses.vue";
import ShowWarehouse from "@/views/service_provider/warehouse/movements/ShowWarehouse.vue";
import ShowWarehouseMovementsTab from "@/components/views/service_provider/warehouse/movements/show_warehouse/Movements.vue"
import ShowWarehouseItemsTab from "@/components/views/service_provider/warehouse/movements/show_warehouse/Items.vue"
import NewMovement from "@/views/service_provider/warehouse/movements/NewMovement.vue";
import EditMovement from "@/views/service_provider/warehouse/movements/EditMovement.vue";
import NewItem from "@/views/service_provider/warehouse/movements/NewItem.vue";
import EditItem from "@/views/service_provider/warehouse/movements/EditItem.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "sp",
  role: "warehouse",
  permission: "movements",
});

export default [
  {
    path: "/service_provider/:service_provider_id/warehouse/movements",
    name: routeName(""),
    component: ListWarehouses,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/warehouse/movements/show_warehouse/:warehouse_id",
    name: routeName("show_warehouse"),
    redirect: { name: routeName("show_warehouse_movements") },
    component: ShowWarehouse,
    props: true,
    meta: META,
    children: [
      {
        path: "movements",
        name: routeName("show_warehouse_movements"),
        component: ShowWarehouseMovementsTab,
        props: true,
        meta: META,
      },
      {
        path: "items",
        name: routeName("show_warehouse_items"),
        component: ShowWarehouseItemsTab,
        props: true,
        meta: META,
      },
    ]
  },
  {
    path: "/service_provider/:service_provider_id/warehouse/movements/new_movement/:warehouse_id/:movement_type",
    name: routeName('new_movement'),
    component: NewMovement,
    props: true,
    meta: META,
  },
  {
    path: "/service_provider/:service_provider_id/warehouse/movements/edit_movement/:warehouse_id/:id",
    name: routeName('edit_movement'),
    component: EditMovement,
    props: true,
    meta: META,
  },
  {
    path: "/service_provider/:service_provider_id/warehouse/movements/new_item/:warehouse_id",
    name: routeName('new_item'),
    component: NewItem,
    props: true,
    meta: META,
  },
  {
    path: "/service_provider/:service_provider_id/warehouse/movements/edit_item/:warehouse_id/:id",
    name: routeName('edit_item'),
    component: EditItem,
    props: true,
    meta: META,
  }
];
